import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    ordersText: translate({ id: 'global.orders' }),
    copyAllToOperations: translate({ id: 'global.copyAllToOperations' }),
    mixedAddressesText: translate({ id: 'orders.mixedAddresses' }),
    duplicateAll: translate({ id: 'global.duplicateAll' }),
    export: translate({ id: 'global.exportAll' }),
    unassign: (allUnassigned: boolean, count: number) => {
      if (allUnassigned) return translate({ id: 'global.unassign' })
      return translate({ id: 'global.unassign.withCount', values: { count } })
    },
    fitIn: (allUnassigned: boolean, count: number) => {
      if (allUnassigned) return translate({ id: 'rm.contextual.order.fitInAll' })
      return translate({ id: 'rm.contextual.order.fitIn.withCount', values: { count } })
    },

    delete: translate({ id: 'global.delete' }),
    edit: translate({ id: 'global.edit' }),
    more: translate({ id: 'global.more' }),
  }))

  return api
}
